export default __webpack_public_path__ + "c75f0dc88139635b04f967360042176f.png";